import { useTheme } from 'next-themes'
import { Toaster as Sonner, ToasterProps } from 'sonner'

const Toaster = ({ ...props }: ToasterProps) => {
	const { theme = 'system' } = useTheme()

	return (
		<Sonner
			theme={theme as ToasterProps['theme']}
			className="toaster group"
			toastOptions={{
				classNames: {
					toast: props.richColors
						? // Removed everything where shadcn+tailwind affected the colors
							'group-[.toaster]:border group-[.toaster]:shadow-lg'
						: 'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border group-[.toaster]:shadow-lg',
					description: 'group-[.toast]:text-muted-foreground',
					actionButton:
						'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground font-medium',
					cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground font-medium',
				},
			}}
			{...props}
		/>
	)
}

export { Toaster }
